import { countryList } from '../../../data/countryList';
import React, { useState } from 'react';
import { Select } from 'antd';
const { Option } = Select;
export function isEmptyPlaceholder(data) {
  return !!data ? data : 'N.A.';
}
export const DEFAULT_COMMISSION_TYPE = 'percent';
export const DEFAULT_SENDER_EMAIL = 'hello@nasacademy.com';
export const DEFAULT_EFFECTIVE_FROM_VALUE = new Date().setFullYear(1990); //random date in the past
export function findCountryName(id) {
  return countryList.find((data) => data.id === id)?.name;
}
export const countryListMenu = countryList.map((country) => (
  <Option key={country.id} value={country.id}>
    {country.name}
  </Option>
));
